import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ActivityType } from '../common/constants.lib';
import { LoggerService } from '../shared/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class TrackerApiService {

  constructor(
    private apiService: ApiService,
    private logger: LoggerService
  ) {
  }

  trackIt(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`logtrackactivity`, p, 'trackIt');
  }

  logActivity(msg: ActivityType = 'No activity', source: any): void {
    this.logger.debug(`logActivity: `, {
      msg,
      source
    });
    this.trackIt({
      activityMeta: {
        title: 'Log activity'
      },
      bodyMeta: {
        name: source.constructor.name,
        activity: msg
      }
    });

  }

}
